<template>
  <div v-loading="loading">
    <pt-page-title :title="`${isEdit ? '编辑' :'新建'}检测项目`">
    </pt-page-title>
    <pt-lab-product-form ref="form" :value="currentForm" class="pt-lab-product-form__withData"></pt-lab-product-form>
    <div class="button-div">
      <el-button type="primary" @click="save">提交</el-button>
      <el-button type="primary" plain @click="cancel">取消</el-button>
      <el-button type="danger" v-if="isEdit" @click="goDelete(currentForm)">删除</el-button>
    </div>
  </div>

</template>

<script>
import PtLabProductForm from './index'
export default {
  name: 'pt-lab-product-form__withData',
  components: {
    'pt-lab-product-form': PtLabProductForm
  },
  computed: {
    form () {
      return this.$refs.form
    },
    isEdit () {
      return this.$route.params.isEdit !== 'false'
    }
  },
  data () {
    return {
      loading: false,
      currentForm: {
        dayType: 'WORK_DAY',
      }
    }
  },
  methods: {
    goDelete (data) {
      this.$confirm('确定要删除检测项目' + data.itemName + '?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('deleteLabProduct', data.id).then(res => {
          this.$message.success('删除成功!')
          this.loading = false
          this.$router.push('/lab-product')
        }).catch(err => {
          this.loading = false
          console.error(err)
          this.$message.error('删除失败!')
        })
      })
    },
    save () {
      let form = {
        ...this.form.currentData,
        testCycle:this.form.currentData.testCycle?'P0Y0M' + this.form.currentData.testCycle + 'D':''
      }
      if(form.attachments){
        form.attachments =  form.attachments.map(e=>{
          return{
            name: e.name,
            type:'EXAM_METHOD_PDF',
            ossUrl: e.response || e.url,
            uploadTime:new Date().getTime(),
            uploadUser:this.$auth.user().id
          }
        })
      }
      if(typeof form.examBasis === 'string'){
        form.examBasis = {
          name:form.examBasis,
          description:form.examBasis,
          isCustom:true
        }
      }

      this.form.validate().then(formValue => {
        this.loading = true
        this.isEdit ? this.edit(form) : this.create(form)
      })
    },
    async create (val) {

      this.$store.dispatch('labProductAdd', val).then(data => {
        this.loading = false
        this.$message.success('创建成功！')
        this.cancel()
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    },
    async edit (val) {
      this.$store.dispatch('updateLabProduct', val).then(data => {
        this.loading = false
        this.$message.success('保存成功！')
        this.cancel()
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    },
    cancel () {
      history.go(-1)
    },
    load () {
      this.loading = true
      this.$store.dispatch('getLabProduct', this.$route.params.id).then(data => {
        this.loading = false
        if (data.testCycle) {
          data.testCycle = data.testCycle.replace(/[^0-9]/ig, '')
        }
        if (data.examBasis.isCustom) {
          data.examBasis = data.examBasis.name
        }
        this.currentForm = data
        console.log('this.currentForm', this.currentForm)
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    }
  },
  created () {
    console.log('===his.$auth.user()',this.$auth.user())
    if (this.isEdit) {
      this.load()
    }
  }
}
</script>
